"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _chatModReactComponentsTips = require("@olxbr/chat-mod-react-components-tips");
var _propTypes = require("prop-types");
var _dsIcons = require("@olxbr/ds-icons");
var _TipBox = _interopRequireDefault(require("../TipBox"));
var _SecurityDetail = _interopRequireDefault(require("./components/SecurityDetail"));
var _TipBoxSysSafety = require("../TipBoxSysSafety");
var _selectors = require("../../../selectors");
var _actions = require("../../../actions");
var _platform = require("../../../helpers/platform");
var _ChatSecurityTip = require("./components/ChatSecurityTip");
var _isSsr = require("../../../helpers/isSsr");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var SecurityBox = function SecurityBox(_ref) {
  var _ref$subType = _ref.subType,
    subType = _ref$subType === void 0 ? '' : _ref$subType,
    _ref$tip = _ref.tip,
    tip = _ref$tip === void 0 ? null : _ref$tip,
    adIsAuto = _ref.adIsAuto,
    amISellerSelector = _ref.amISellerSelector,
    currentUser = _ref.currentUser,
    isFirstChat = _ref.isFirstChat,
    chatId = _ref.chatId,
    _ref$myAccountId = _ref.myAccountId,
    userAccountId = _ref$myAccountId === void 0 ? null : _ref$myAccountId,
    _ref$senderMessageTip = _ref.senderMessageTip,
    tipSenderAccountId = _ref$senderMessageTip === void 0 ? '' : _ref$senderMessageTip,
    openModalAction = _ref.openModalAction,
    chatSecurity = _ref.chatSecurity,
    contentModRatingTipVariant = _ref.contentModRatingTipVariant,
    partnerName = _ref.partnerName;
  var showSecurityDetails = function showSecurityDetails() {
    var tipOptions = _getTipOptions();
    openModalAction( /*#__PURE__*/(0, _jsxRuntime.jsx)(_SecurityDetail["default"], {
      amISeller: amISellerSelector
    }), amISellerSelector, tipOptions);
  };
  var _getTipOptions = function _getTipOptions() {
    if (tip) {
      var tipType = tip.type,
        _tipText = tip.value,
        tipVisibleTo = tip.visibleTo;
      return {
        tipType: tipType,
        tipText: _tipText,
        tipSenderAccountId: tipSenderAccountId,
        tipVisibleTo: tipVisibleTo,
        userAccountId: userAccountId
      };
    }
    return {};
  };
  var _getTexts = function _getTexts() {
    var safeTradingText = 'Saiba como usar o chat da melhor forma' + 'e ter uma negociação segura.';
    if (!tip && adIsAuto) {
      return {
        tip: amISellerSelector ? 'Prefira fechar diretamente com o interessado pelo seu veículo.' + 'Cuidado com intermediadores se pedirem para ocultar' + 'informações do comprador.' : safeTradingText,
        link: 'Ver outras dicas'
      };
    }
    var _ref2 = tip || {},
      _ref2$text = _ref2.text,
      text = _ref2$text === void 0 ? safeTradingText : _ref2$text;
    return {
      tip: text,
      link: tip ? 'Ver mais dicas' : 'Ver dicas'
    };
  };
  if (!tip) {
    return chatSecurity ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatSecurityTip.ChatSecurityTip, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_chatModReactComponentsTips.FirstTip, {
      chatId: chatId,
      isFirstChat: isFirstChat,
      isSeller: amISellerSelector,
      isAutoAd: adIsAuto,
      isMsite: _platform.isMsite,
      accountId: currentUser
    });
  }
  var _getTexts2 = _getTexts(),
    tipText = _getTexts2.tip,
    linkText = _getTexts2.link;
  if (subType === 'tip-RATING' || subType === 'tip-EASTER_EGG_RATING') {
    if (_chatModReactComponentsTips.RateTip && contentModRatingTipVariant !== 'control') {
      return (0, _isSsr.isCsr)() && /*#__PURE__*/(0, _jsxRuntime.jsx)(_chatModReactComponentsTips.RateTip, {
        chatId: chatId,
        accountId: currentUser,
        textVariant: contentModRatingTipVariant,
        partnerName: partnerName
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  } else if (subType) {
    var TipBoxSafety = (0, _TipBoxSysSafety.getTipBoxSysSafety)(subType);
    if (TipBoxSafety) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(TipBoxSafety, {
        text: tipText,
        onPress: showSecurityDetails,
        children: linkText
      });
    }
  }
  return tipText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_TipBox["default"], {
    tip: {
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.TrustShield, {}),
      text: tipText,
      cta: linkText,
      links: {
        web: showSecurityDetails
      }
    },
    variant: "default"
  });
};
SecurityBox.propTypes = {
  amISellerSelector: _propTypes.bool.isRequired,
  myAccountId: _propTypes.string,
  openModalAction: _propTypes.func.isRequired,
  tip: _propTypes.object,
  subType: _propTypes.string,
  adIsAuto: _propTypes.bool.isRequired,
  currentUser: _propTypes.string.isRequired,
  chatSecurity: _propTypes.bool.isRequired,
  contentModRatingTipVariant: _propTypes.string.isRequired
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    amISellerSelector: (0, _selectors.amISeller)(state),
    adIsAuto: (0, _selectors.isAuto)(state),
    currentUser: (0, _selectors.getCurrentUser)(state),
    isFirstChat: (0, _selectors.isFirstChat)(state),
    chatId: (0, _selectors.getChatId)(state),
    chatSecurity: (0, _selectors.isChatSecurity)(state),
    contentModRatingTipVariant: (0, _selectors.showContentModRatingTip)(state),
    partnerName: (0, _selectors.getCurrentPartnerName)(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    openModalAction: _actions.openSecurityModal
  }, dispatch);
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps, mapDispatchToProps)(SecurityBox);